<template>
  <v-app>
    <router-view />
    <modals-container />
    <v-overlay
      :model-value="isLoading && enabledLoading"
      class="align-center justify-center"
      opacity="0.3"
      persistent
    >
      <v-progress-circular
        color="primary"
        indeterminate="disable-shrink"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ModalsContainer } from "vue-final-modal";
import appErrorHandler from "@/error/app-error-handler";
import { mapGetters, mapState } from "vuex";

export default defineComponent({
  name: "AppVue",
  components: { ModalsContainer },
  computed: {
    ...mapGetters("meta", {
      isLoading: "isLoading",
    }),
    ...mapState("meta", {
      enabledLoading: "enabledLoading",
    }),
  },
  created() {
    window.addEventListener("error", this.errorHandler);
    window.addEventListener("unhandledrejection", this.errorHandler);
  },
  unmounted() {
    window.removeEventListener("error", this.errorHandler);
    window.removeEventListener("unhandledrejection", this.errorHandler);
  },
  methods: {
    /**
     * 全体エラーハンドラー。VueのerrorHandlerではcatch出来ないものをここで拾う
     * @param event イベント
     */
    errorHandler(event: ErrorEvent | PromiseRejectionEvent): void {
      if ("error" in event) {
        appErrorHandler(event.error, this);
      } else {
        appErrorHandler(event.reason, this);
      }
    },
  },
});
</script>
